// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Js_dict from "../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Float from "../../../../node_modules/rescript/lib/es6/belt_Float.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as OptimizeLog$Showside from "./OptimizeLog.bs.js";
import * as Webapi__Dom__Document from "../../../../node_modules/rescript-webapi/lib/es6_global/src/Webapi/Dom/Webapi__Dom__Document.bs.js";
function parseQueryString(queryString) {
  var dict = {};
  var pairs = queryString.substr(1).split("&");
  Belt_Array.forEach(pairs, function (pair) {
    var kv = pair.split("=");
    if (kv.length !== 2) {
      return;
    }
    var key = kv[0];
    var value = kv[1];
    dict[key] = decodeURIComponent(value);
  });
  return dict;
}
function gatherPageParams(param) {
  return {
    url: window.location.href,
    host: window.location.host,
    path: window.location.pathname,
    queryParams: parseQueryString(window.location.search),
    hash: window.location.hash.replace("#", "")
  };
}
function getCookies(param) {
  var htmlDocument = Webapi__Dom__Document.asHtmlDocument(document);
  return Js_dict.fromArray(Belt_Array.map(htmlDocument.cookie.split(";"), function (cookie) {
    var parts = cookie.split("=");
    var key = Belt_Option.getWithDefault(Belt_Array.get(parts, 0), "").trim();
    var value = Belt_Array.joinWith(Belt_Array.slice(parts, 1, parts.length - 1 | 0), "=", function (a) {
      return a;
    }).trim();
    return [key, value];
  }));
}
var getWindowVariable = function (name) {
  try {
    return String(window[name]);
  } catch (e) {
    return undefined;
  }
};
function gatherWindowVariable(experiments) {
  return Js_dict.fromArray(Belt_Array.map(Belt_Array.keep(Belt_Array.concatMany(Belt_Array.map(experiments, function (exp) {
    return Belt_Array.concat(Belt_Option.getWithDefault(exp.audienceTargetRule.conditions.all, []), Belt_Option.getWithDefault(exp.audienceTargetRule.conditions.any, []));
  })), function (rule) {
    return rule.fact === "JS Variable";
  }), function (rule) {
    var name = Belt_Option.getWithDefault(rule.path, "").replace("$.", "");
    return [name, Belt_Option.getWithDefault(getWindowVariable(name), "")];
  }));
}
function getReferrer(param) {
  return Belt_Option.getWithDefault(Caml_option.nullable_to_opt(document.referrer), "");
}
function setCookie(name, value, days) {
  var expires = new Date();
  expires.setTime(expires.getTime() + 1000 * 60 * 60 * 24 * days);
  Webapi__Dom__Document.asHtmlDocument(document).cookie = name + "=" + value + ";expires=" + expires.toUTCString() + ";path=/";
}
function isReturningVisitor(cookies) {
  var cookieName = "maker_returning_visitor";
  var value = Js_dict.get(cookies, cookieName);
  var value$1 = Belt_Option.flatMap(value, Js_json.decodeString);
  var value$2 = value$1 === "true" ? String(Date.now() - 8 * 24 * 60 * 60 * 1000) : value$1;
  var value$3 = Belt_Option.flatMap(value$2, Belt_Float.fromString);
  var value$4 = value$3 !== undefined ? value$3 : Date.now();
  setCookie(cookieName, String(value$4), 730);
  return Date.now() - value$4 > 7 * 24 * 60 * 60 * 1000;
}
function getRememberVisitorCookieName(experiment) {
  return "maker_remember_visitor_" + experiment.id;
}
function rememberVisitor(experiment, variant) {
  setCookie("maker_remember_visitor_" + experiment.id, Belt_Option.getWithDefault(variant.targetId, ""), 30);
}
async function getFacts(experiments, embedType, enhanceId, param) {
  var pageFacts = gatherPageParams(undefined);
  var cookies = getCookies(undefined);
  var hasCookies = Object.keys(Belt_Option.getWithDefault(Js_json.decodeObject(cookies), {})).length !== 0;
  var tmp;
  if (hasCookies) {
    var tmp$1;
    switch (embedType) {
      case /* Bottombar */0:
        tmp$1 = "bottombar";
        break;
      case /* Inline */1:
        tmp$1 = "";
        break;
      case /* Launcher */2:
        tmp$1 = "launcher";
        break;
      case /* Section */3:
        tmp$1 = "section";
        break;
      case /* Menu */4:
        tmp$1 = "menu";
        break;
      case /* ProductDetailsPage */5:
        tmp$1 = "pdp";
        break;
    }
    tmp = [["Cookie", cookies], ["JS Variable", gatherWindowVariable(experiments)], ["Nav Type", tmp$1], ["Enhance ID", Belt_Option.getWithDefault(enhanceId, "")], ["Referrer URL", getReferrer(undefined)], ["Query Param", pageFacts.queryParams], ["Hash", pageFacts.hash], ["URL", pageFacts.url], ["Host", pageFacts.host], ["Path", pageFacts.path], ["Returning Visitor", isReturningVisitor(Belt_Option.getWithDefault(Js_json.decodeObject(cookies), {}))]];
  } else {
    tmp = [];
  }
  var facts = Js_dict.fromArray(tmp);
  OptimizeLog$Showside.logFacts(facts);
  return facts;
}
export { parseQueryString, gatherPageParams, getCookies, getWindowVariable, gatherWindowVariable, getReferrer, setCookie, isReturningVisitor, getRememberVisitorCookieName, rememberVisitor, getFacts };
/* Webapi__Dom__Document Not a pure module */